import React, { useContext } from "react";
import AppContext from "../context/AppContext";
import translations from "../components/common/Translations";
import CommonButton from "../components/common/CommonButton";
import { hasScreenAccess } from "../utils/permissions";

const ProtectedRoute = ({
  children,
  privilegesRequired,
  screenCode,
  requiredPermission = "canView",
}) => {
  const { user, langMode } = useContext(AppContext);

  const hasRequiredPrivileges = Array.isArray(privilegesRequired)
    ? Boolean(user) && privilegesRequired.every((privilege) => user?.[privilege] !== false)
    : true;

    const hasRequiredScreenPermission = !screenCode
      ? true
      : (Array.isArray(screenCode) ? screenCode : [screenCode]).some(code => hasScreenAccess(code, requiredPermission));

  const isAllowed = hasRequiredPrivileges && hasRequiredScreenPermission;

  if (isAllowed) {
    return children;
  } else {
   
    return (
      <>
        <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex justify-center items-center z-50">
          <div className="bg-white p-5 rounded-lg shadow-xl">
            <h2 className="text-sm font-semibold text-red-600">
              {translations[langMode].accessdenied}
            </h2>
            <p className="texts-sm">
              {translations[langMode].nopermission}
            </p>
            <CommonButton colorIntent="primary"
              variant="primary"
              tooltipText={translations[langMode].requestreporbasedonfilter}
              tooltipPosition="top"
              style={{ whiteSpace: "nowrap" }}
              onClick={() => window.history.back()}
            >
              {translations[langMode].goback}
            </CommonButton>
          </div>
        </div>
        <div className="filter blur-sm">{children}</div>
      </>
    );
  }
};

export default ProtectedRoute;
